"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Widget = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 5V2h3v3H2zM0 1a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1V1zm2 13v-3h3v3H2zm-2-4a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H1a1 1 0 01-1-1v-5zm11-8v3h3V2h-3zm-1-2a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1h-5zm3.207 8.258a1 1 0 00-1.414 0l-3.536 3.535a1 1 0 000 1.415l3.536 3.535a1 1 0 001.414 0l3.536-3.535a1 1 0 000-1.415l-3.536-3.535z",
  className: "fill"
}));

var _default = Widget;
exports.default = _default;